export default "__VITE_ASSET__Bd96xGaP__"